goog.provide("shadow.js.shim.module$dayjs$locale$sl");
goog.provide("module$shadow_js_shim_module$dayjs$locale$sl");
shadow.js.shim.module$dayjs$locale$sl = shadow.js.nativeProvides["dayjs/locale/sl"] = require("dayjs/locale/sl");
module$shadow_js_shim_module$dayjs$locale$sl.default = shadow.js.shim.module$dayjs$locale$sl;
